// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1KN0t","buttons":"RemoveExpirationActionButtons_buttons__1Or1m"};